import { RCI_THEME, CEL_THEME } from '@rcg/ui-components';
import {
  BRAND_RCI,
  BRAND_CEL,
} from 'contexts/CruiseSearchContext/constants.js';

const getBrandTheme = brand => {
  const brandTheme = {
    [BRAND_RCI.code]: RCI_THEME,
    [BRAND_CEL.code]: CEL_THEME,
  };

  return brandTheme[brand];
};

const getBrandUISettings = brand => {
  const brandUISettings = {
    [BRAND_RCI.code]: BRAND_RCI,
    [BRAND_CEL.code]: BRAND_CEL,
  };

  return brandUISettings[brand];
};

export { getBrandTheme, getBrandUISettings };
